import React from 'react';
import { Redirect } from 'react-router-dom';
import { ErrorMessage } from 'formik'
import SubDocument from '../SubDocument';
import Hospital from '../Hospital';
import AddDocument from '../AddDocument';
import HandleSubmission from '../HandleSubmission'

import { Card, 
  CardBody,
  Form,
  Row,
  Col,
  Button
} from 'reactstrap'

const MedicalForm = (props) => {


  // if(props.status.redirect == 1 && props.isSubmitting == false) {
  //   return <Redirect to="/generalmedicalrecord" />
  // } else if(props.status.redirect == 2 && props.isSubmitting == false) {
  // }

  return  (
    <Card>
      <CardBody>
        <Form>
          <Row>
            <SubDocument
              subDocumentType={props.values.subDocumentType} 
              subDocuments={props.status.subDocumentsOption}
              setFieldValue={props.setFieldValue}
              errors={props.errors}
              touched={props.touched}
            />
            {/* <ErrorMessage name="subDocumentType">{msg => <div id="feedback" className="text-danger">{msg.value}</div>}</ErrorMessage> */}
          </Row>
          <Hospital values={props.values}
            handleChange={props.handleChange}
            errors={props.errors}
            touched={props.touched}
          />
          <React.Fragment>
            <AddDocument 
              type={props.values.type}
              category={props.values.category}
              documentType={props.status.documentType}
              documentsOption={props.values.documentsOption}
              fileInputKey={props.submitCount} 
              title={props.values.document.title}
              description={props.values.document.description}
              appointment={props.values.document.appointment}
              handleChange={props.handleChange}
              setFieldValue={props.setFieldValue}
              files={props.values.files}
              uploadedFiles={props.status.files}
              errors={props.errors}
              touched={props.touched}
              formType={props.formType}
              deleteImage={props.deleteImage}
            />
          </React.Fragment>
          {/* <ErrorMessage name="document.title">{msg => <div id="feedback" className="text-danger">{msg}</div>}</ErrorMessage> */}
          {/* <div className="text-center">                
            <Button className="btn" onClick={async (e) => {
              await props.setFieldValue("redirect", true);
              props.submitForm();
            }}>Save</Button>
            <Button className="btn" onClick={(e) => {
              props.submitForm();
            }}>Save & Add new record</Button>
          </div> */}
          <HandleSubmission 
            setFieldValue={props.setFieldValue}
            submitForm={props.submitForm}
            formType={props.formType}
          />
        </Form>
      </CardBody>
    </Card>
  )
}

export default MedicalForm;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/GeneralMedicalRecord/MedicalForm.js